module.exports = __webpack_public_path__ + "static/media/donna-mobile@2x.e7118a61.jpg";